import React from 'react';
import { PropertyGrid, Pane, NumericInput, Label } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelTypeSelector } from '@leverege/ui-plugin';
import { Colorizers } from '@leverege/ui-attributes';
import { ns } from '@leverege/i18n';
import DotGlyphModel from "../../models/glyph/DotGlyphModel.js";
const {
  t
} = ns('ui-attributes-graphs.editors.DotGlyphEditor');
export default function DotGlyphEditor(props) {
  const {
    value,
    objectType
  } = props;
  const onModelChange = useValueChange(DotGlyphModel, props);
  return /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "glyphEditor|editor",
    inline: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('size')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    value: DotGlyphModel.getSize(value),
    eventData: "setSize",
    onChange: onModelChange
  })), ModelTypeSelector.createSelectorAndEditor({
    modelKey: 'colorizer',
    values: Colorizers.getColorizersFor(objectType),
    value: DotGlyphModel.getStroke(value),
    eventData: 'setStroke',
    onChange: onModelChange,
    isPropertyGrid: true,
    propertyGridOpts: {
      preLabel: /*#__PURE__*/React.createElement(Label, null, t('strokeColor'))
    }
  }), ModelTypeSelector.createSelectorAndEditor({
    modelKey: 'colorizer',
    values: Colorizers.getColorizersFor(objectType),
    value: DotGlyphModel.getFill(value),
    eventData: 'setFill',
    onChange: onModelChange,
    isPropertyGrid: true,
    propertyGridOpts: {
      preLabel: /*#__PURE__*/React.createElement(Label, null, t('fillColor'))
    }
  }));
}